define('views/modules/calendar/nutrition/food/edit/food-edit-modal',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    'services/i18n',
    // models
    'models/calendar/nutrition/food',
    // events
    'services/events/nutrition-events',
    // views
    'views/parts/modal/modal',
    'views/modules/calendar/nutrition/food/edit/food-form'
], function(
    // Libs
    _, Backbone, Mustache, U,
    // services
    i18n,
    // models
    MFood,
    // events
    NutritionEvents,
    // views
    VModal,
    VFoodForm
) {

    var VFoodEditModal = VModal.extend({
        modal: function() {
            return {
                title: i18n.t("Create food"),
                className: "food-edit-modal",
            };
        },
        buttons: function(buttons) {
            return _.extend(buttons, {
                confirm: {
                    label: i18n.t("Create"),
                    callback: this.onConfirm
                },
            });
        },
        initialize: function(options) {
            options = options || {};
            var model = this.model;

            if (!model) model = this.model = new MFood();

            var view = this.view = {
                form: new VFoodForm({
                    model: model
                }),
            };

            this.listenTo(view.form, {
                "form:success": this.onSuccess
            });
        },

        render: function() {
            this.$el.empty()
                .append(this.view.form.render().el);
            return this.renderModal();
        },

        resetModel: function(attrs, options) {
            this.model.reset(attrs, options);
            return this;
        },

        ////////////
        // events //
        ////////////
        onConfirm: function(confirmed) {
            var form = this.view.form;

            if (confirmed) {
                form.submit();
                return false;
            }

            // default, modal dismissed
            form.setPristine();
            this.disable();
            return;
        },

        onSuccess: function() {
            this.close();
            this.trigger('success', this.model);
            NutritionEvents.showFavorites();
        },

    });

    return VFoodEditModal;

});

